export default function Benefits() {
  const benefits = [
    'More customers from the same traffic',
    'Faster responses without watching your phone',
    'Fewer missed opportunities',
    'More professional communication'
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6 lg:px-12">
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 text-center mb-16">
          What Changes After Automigo
        </h2>

        <div className="space-y-4 mb-12">
          {benefits.map((benefit, index) => (
            <div key={index} className="flex items-start gap-4 bg-white rounded-xl p-6 shadow-sm">
              <div className="flex-shrink-0 w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center">
                <i className="ri-check-line text-teal-600 text-lg"></i>
              </div>
              <p className="text-lg text-gray-900 pt-1">
                {benefit}
              </p>
            </div>
          ))}
        </div>

        <p className="text-2xl font-bold text-gray-900 text-center">
          You don't need more leads —<br />
          you need to capture the ones you already get.
        </p>
      </div>
    </section>
  );
}
